import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  VIZ,
  axisStyle,
  tooltipStyle,
  crosshairPlugin,
  withAlpha,
  formatNumber,
  seriesColor,
  legendStyle,
} from '../chartTheme';

/**
 * Change over time for one or more count series on a shared scale. Two measures
 * of different units never share a plot here - a second y-axis invents
 * correlations - so fees get their own chart.
 *
 * The legend is always on, even for a single series, so every line on the card
 * says what it counts ("which colour denotes what" never has to be guessed).
 */
export default function TrendLine({ labels, datasets, valueFormatter = formatNumber }) {
  const single = datasets.length === 1;

  return (
    <Line
      data={{
        labels,
        datasets: datasets.map((set, index) => {
          const color = seriesColor(index, set.color);
          return {
            label: set.label,
            data: set.data,
            borderColor: color,
            backgroundColor: single ? withAlpha(color, 0.1) : color,
            fill: single,
            borderWidth: 2,
            tension: 0.25,
            pointRadius: datasets.length > 3 ? 3 : 4,
            pointHoverRadius: 6,
            pointBackgroundColor: color,
            pointBorderColor: VIZ.surface,
            pointBorderWidth: 2,
            pointHitRadius: 24,
          };
        }),
      }}
      plugins={[crosshairPlugin]}
      options={{
        maintainAspectRatio: false,
        interaction: { mode: 'index', intersect: false },
        scales: {
          x: axisStyle(false),
          y: { ...axisStyle(true), beginAtZero: true, ticks: { ...axisStyle().ticks, maxTicksLimit: 5 } },
        },
        plugins: {
          legend: legendStyle({
            labels: { usePointStyle: true, pointStyle: 'line', boxWidth: 18 },
          }),
          tooltip: tooltipStyle(valueFormatter),
        },
      }}
    />
  );
}
